export const CUSTOM_PART_NUMBER = 'QUOTEPART';
